import { Icon, spacing, Text } from '@scality/core-ui';
import styled from 'styled-components';
import type { Alert } from '../gen/openapi';

const AlertAnalysisBox = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.backgroundLevel3};
  border-radius: ${spacing.f8};
`;

const AlertAnalysisIcon = styled(Icon)`
  color: ${(props) => props.theme.textSecondary};
  margin-right: ${spacing.r8};
`;

const AlertAnalysisBoxTitle = styled(Text)`
  padding: ${spacing.r8} 0 0 ${spacing.r16};
`;

const AlertList = styled.ul`
  color: ${(props) => props.theme.textSecondary};
  padding-left: ${spacing.r16};
  font-style: italic;
  list-style-position: inside;
  margin: ${spacing.r8} 0;
`;

export const AlertAnalysis: React.FC<{ alerts: Alert[] }> = ({ alerts }) => {
  return (
    <AlertAnalysisBox>
      <AlertAnalysisBoxTitle>
        <AlertAnalysisIcon name="Info-circle" />
        &nbsp;Agent analysis:
      </AlertAnalysisBoxTitle>
      <AlertList>
        {alerts.map((alert, index) => (
          <li key={index}>
            <Text>
              {alert.severity} - {alert.description} on {alert.instanceId}
            </Text>
          </li>
        ))}
      </AlertList>
    </AlertAnalysisBox>
  );
};
